<script setup lang="ts">
import { useError, useLocalePath } from '#imports'

// ** Pinia Store
// ** Data
const localePath = useLocalePath()
const error = useError()

watchEffect(() => {
  useHead({
    title: 'Page Not Found',
  })
})
function handleClick() {
  window.location.href = localePath({
    name: 'home',
  })
}
</script>

<template>
  <div
    class="section-not-found"
  >
    <div class="relative mx-auto mt-28 container">
      <div class="flex flex-col-reverse items-stretch lg:!flex-row">
        <div class="self-center lg:!w-1/3">
          <div class="flex flex-col items-stretch bg-white p-7 lg:h-[55vh] lg:shadow-lg">
            <div class="my-auto flex flex-col items-stretch">
              <h1 class="font-primary text-[var(--color-primary)]">
                {{ error?.statusCode }} {{ error?.statusMessage || 'Error' }}
              </h1>
              <p class="font-secondary my-10 color-gray">
                Oh no! We can't seem to find the page you're looking for. It may have been moved, removed, or renamed.
              </p>
              <button
                type="button"
                class="w-40 hover:!cursor-pointer hover:!border-[var(--color-secondary)] hover:!bg-[var(--color-secondary)]"
                @click.prevent="handleClick"
              >
                Back to Home
              </button>
            </div>
          </div>
        </div>
        <div class="lg:!w-2/3">
          <NuxtImg
            src="https://static.pbahotels.com/Assets/images/Hotel/exterior/916c5d0c171110cf569f866a40cd0420be548a87.jpg"
            width="1024"
            height="539"
            :placeholder="[1024, 539, 55, 5]"
            loading="lazy"
            alt="404 not found"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(h1) {
  font-size: 4rem;
  line-height: normal;
}
:deep(p) {
  font-size: 1.4rem;
}
</style>
